import { ScheduleDayProps } from '../types'

export const tuesdayData: ScheduleDayProps = {
  title: 'Tuesday · July 22 — Track-Specific Training',
  gridCols: 6,
  headers: [
    { name: 'Time', location: '' },
    {
      name: 'Pinnacle',
      location: 'Pinnacle',
      color: '#894d35',
      textColor: 'white'
    },
    {
      name: 'Blood Bank',
      location: 'Stowe North',
      color: '#A6410A',
      textColor: 'white'
    },
    {
      name: 'Neurocog',
      location: 'Stowe South',
      color: '#A0B2B4',
      textColor: '#3C2416'
    },
    {
      name: 'Pharmacy',
      location: 'Beatrice',
      color: '#9298a8',
      textColor: '#3C2416'
    },
    {
      name: 'Psychiatrist',
      location: 'Green Mountain',
      color: '#894d35',
      textColor: 'white'
    }
  ],
  rows: [
    {
      time: '8:00 – 9:00 AM',
      sessions: [
        {
          text: 'Breakfast In Pinnacle',
          span: 5,
          isBold: true,
          isCentered: true
        }
      ]
    },
    {
      time: '9:00 – 10:00 AM',
      sessions: [
        { text: 'N/A', isMuted: true },
        {
          text: 'Existing Acute and Chronic Transfusion Indications and Supporting Evidence',
          speaker: 'Yvette Tanhehco, MD'
        },
        {
          text: 'Neurocognitive Workshop On Brief Neurocognitive & Neurodevelopmental Screening Tools'
        },
        {
          text: 'Hydroxyurea Management',
          speaker: 'Pat McGann MD'
        },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '10:00 – 10:45 AM',
      sessions: [
        { text: 'N/A', isMuted: true },
        {
          text: 'Product Selection (Immunohematology, RBC Genotyping/Phenotyping)',
          speaker: 'Stella Chou, MD'
        },
        {
          text: 'Neurocognitive Workshop On Brief Neurocognitive & Neurodevelopmental Screening Tools'
        },
        {
          text: 'Anticoagulation Therapy',
          speaker: 'Mark R. Attilio, PharmD'
        },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '10:45 – 11:15 AM',
      sessions: [
        { text: 'N/A', isMuted: true },
        { text: 'Coffee & Questions' },
        { text: 'Coffee & Questions' },
        { text: 'Coffee & Questions' },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '11:15 AM – 12:00 PM',
      sessions: [
        { text: 'N/A', isMuted: true },
        {
          text: 'Premedication, Transfusion Reactions, DHTRs*',
          speaker: 'Jeanne Hendrickson, MD (virtual)'
        },
        {
          text: 'Q&A - Implementation Of Consensus Standards And Recommendations - Open To Any Questions'
        },
        { text: 'Iron Chelation', speaker: 'Shen-Li Chen, PharmD' },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '12:00 – 1:00 PM',
      sessions: [
        { text: 'Lunch In Pinnacle', span: 2, isBold: true, isCentered: true },
        { text: 'Lunch - Closed Neurocog Workgroup Meeting' },
        { text: 'Lunch In Pinnacle', span: 2, isBold: true, isCentered: true }
      ]
    },
    {
      time: '1:00 – 1:45 PM',
      sessions: [
        {
          text: 'Industry Presentations (All Member Center Leads Requested For Industry Sessions)'
        },
        { text: 'Transfusion Consensus Meeting' },
        { text: 'N/A', isMuted: true },
        { text: 'N/A', isMuted: true },
        { text: 'Psychiatrist Workgroup' }
      ]
    },
    {
      time: '1:45 – 2:30 PM',
      sessions: [
        {
          text: 'Industry Presentations (All Member Center Leads Requested For Industry Sessions)'
        },
        { text: 'Transfusion Consensus Meeting' },
        { text: 'N/A', isMuted: true },
        { text: 'N/A', isMuted: true },
        { text: 'Psychiatrist Workgroup' }
      ]
    },
    {
      time: '2:30 – 3:00 PM',
      sessions: [
        {
          text: 'Industry Presentations (All Member Center Leads Requested For Industry Sessions)'
        },
        { text: 'Transfusion Consensus Meeting' },
        { text: 'Bring Your Snacks And Coffee For A Psychology Meet & Greet' },
        { text: 'N/A', isMuted: true },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '3:00 – 4:00 PM',
      sessions: [
        {
          text: 'Industry Presentations (All Member Center Leads Requested For Industry Sessions)'
        },
        { text: 'Transfusion Consensus Meeting' },
        { text: 'N/A', isMuted: true },
        { text: 'N/A', isMuted: true },
        { text: 'N/A', isMuted: true }
      ]
    },
    {
      time: '7:00 PM',
      sessions: [
        {
          text: 'Quilt Health Jam - 80s Theme',
          span: 5,
          isBold: true,
          isCentered: true
        }
      ]
    }
  ]
}

export const wednesdayData: ScheduleDayProps = {
  title: 'Wednesday · July 23 — Multi-Track Clinical Training',
  gridCols: 8,
  headers: [
    { name: 'Time', location: '' },
    {
      name: 'Apheresis',
      location: 'Pinnacle',
      color: '#A6410A',
      textColor: 'white'
    },
    {
      name: 'How I Treat SCD',
      location: 'Stowe North',
      color: '#A0B2B4',
      textColor: '#3C2416'
    },
    {
      name: 'APP Track',
      location: 'Stowe South',
      color: '#AF8A48',
      textColor: '#3C2416'
    },
    {
      name: 'Nursing & Infusion',
      location: 'Beatrice',
      color: '#3C2416',
      textColor: 'white'
    },
    {
      name: 'Pharmacy',
      location: 'Mansfield',
      color: '#9298a8',
      textColor: '#3C2416'
    },
    {
      name: 'SCD for Specialists',
      location: 'Stuart',
      color: '#713d43',
      textColor: 'white'
    },
    {
      name: 'SW / Care Coord / CBO',
      location: 'Green Mountain',
      color: '#894d35',
      textColor: 'white'
    }
  ],
  rows: [
    {
      time: '8:00 – 9:00 AM',
      sessions: [
        {
          text: 'Breakfast in Pinnacle',
          span: 7,
          isBold: true,
          isCentered: true
        }
      ]
    },
    {
      time: '9:00 – 10:00 AM',
      sessions: [
        {
          text: 'Basics of Red Cell Exchange/Therapeutic Plasma Exchange',
          speaker: 'Matt Karafin, MD'
        },
        {
          text: 'Acute Chest Syndrome',
          speaker: 'Neha Bhasin, MD'
        },
        {
          text: 'SAPPORT',
          speaker: ['Earleisha Felder', 'Jennifer Jones']
        },
        {
          text: 'Expanding SCD Treatment Landscape',
          speaker: 'Yvonne Carroll'
        },
        { text: 'Joint SCD Specialist Session (in Stuart)' },
        {
          text: 'SCD Genotype/Phenotype, Pathophysiology and Epidemiology',
          speaker: 'Ward Hagar MD'
        },
        {
          text: 'The Power of Collaboration: Social Work in Healthcare',
          speaker: ['Allison Mcgirr-Crowley', 'Carri Stoker-Postier']
        }
      ]
    },
    {
      time: '10:00 – 10:45 AM',
      sessions: [
        {
          text: 'Vascular Access, Including Issues With Pediatric Patients',
          speaker: 'Suzie Thibodeaux, MD (virtual)'
        },
        {
          text: 'Complex Pain Management',
          speaker: 'Pat Carroll, MD'
        },
        {
          text: 'SCD Certification for APP',
          speaker: 'Ashley Lauriello'
        },
        {
          text: 'SDM & Adherence',
          speaker: 'Lori Vick'
        },
        { text: 'Joint SCD Specialist Session (in Stuart)' },
        {
          text: 'Chronic Organ Dysfunction-Screening & Management',
          speaker: 'Francis Coyne MD'
        },
        { text: 'Panel Discussion - All Committee' }
      ]
    },
    {
      time: '10:45 – 11:15 AM',
      sessions: [
        { text: 'Break' },
        { text: 'Break' },
        { text: 'Break' },
        { text: 'Break' },
        { text: 'Break' },
        { text: 'Break' },
        { text: 'Coffee & Questions' }
      ]
    },
    {
      time: '11:15 AM – 12:00 PM',
      sessions: [
        {
          text: 'Start Consensus Discussion'
        },
        { text: 'Reproductive Health Management', speaker: 'Lydia Pecker, MD' },
        {
          text: 'Leadership & Advancement for APPs',
          speaker: 'Ashley Lauriello'
        },
        {
          text: 'Integrative Approach for Patient Care',
          speaker: 'Maya Bloomberg'
        },
        { text: 'Joint SCD Specialist Session (in Stuart)' },
        { text: 'Reproductive Health Management (in Stowe North)' },
        {
          text: 'Transition: What We Learned and How to Move Forward',
          speaker: ['Terrika Johnson', 'Erin Green-Askew']
        }
      ]
    },
    {
      time: '12:00 – 1:00 PM',
      sessions: [
        { text: 'Lunch in Pinnacle', span: 7, isBold: true, isCentered: true }
      ]
    },
    {
      time: '1:00 – 1:45 PM',
      sessions: [
        {
          text: 'Apheresis Consensus Meeting'
        },
        { text: 'Joint Apheresis Session (in Pinnacle)' },
        {
          text: 'Outpatient APP Consensus Planning',
          speaker: 'Jennifer Saunders'
        },
        {
          text: 'Motivational Interviewing',
          speaker: 'Liz Prince MD'
        },
        {
          text: 'Opioids & Suboxone',
          speaker: 'Mark Attilio (Inpatient 30 min), Pat (Outpatient)'
        },
        {
          text: 'Disease Modifying Therapies (Past, Present, Future)',
          speaker: 'Wally Smith, MD'
        },
        {
          text: 'How To Engage Transition Patients in Planning Their Future as Adults Living with SCD',
          speaker: 'Raven Hines'
        }
      ]
    },
    {
      time: '1:45 – 2:30 PM',
      sessions: [
        {
          text: 'Apheresis Consensus Meeting'
        },
        { text: 'Joint Apheresis Session (in Pinnacle)' },
        { text: 'Inpatient APP Consensus Planning', speaker: 'Mica Fertis' },
        {
          text: 'SDOH',
          speaker: ['Paula Tanabe RN, PhD', 'Stephanie Ibemere PhD']
        },
        { text: 'Reproductive Hormone Management', speaker: 'Lydia Pecker MD' },
        { text: 'Acute VOC & Management', speaker: 'Ashley Jenkins MD, M.Sc.' },
        {
          text: 'Psychotherapy Engagement in SCD Outcomes and Opportunities',
          speaker: 'Caroline Hale'
        }
      ]
    },
    {
      time: '2:30 – 3:00 PM',
      sessions: [
        {
          text: 'Apheresis Consensus Meeting'
        },
        { text: 'Joint Apheresis Session (in Pinnacle)' },
        { text: 'Stretch & Snack' },
        { text: 'Stretch & Snack' },
        { text: 'Stretch & Snack' },
        { text: 'Stretch & Snack' },
        { text: 'Stretch & Snack' }
      ]
    },
    {
      time: '3:00 – 4:00 PM',
      sessions: [
        {
          text: 'Apheresis Consensus Meeting'
        },
        { text: 'Joint Apheresis Session (in Pinnacle)' },
        {
          text: 'More Consensus Planning (if needed)',
          speaker: ['Jennifer Saunders', 'Mica Fertis']
        },
        {
          text: 'Trauma-Informed Care (Combined SW)',
          speaker: 'Allison Mcgirr-Crowley'
        },
        {
          text: 'All the Little Things: Steroids, Bactrim, ESA, Managing CKD',
          speaker: 'JJ Strouse MD'
        },
        {
          text: 'Development of the Sickle Cell Outcomes Grading System (SCOGS)',
          speaker: 'Dr. Sheinei Alan'
        },
        {
          text: 'Combined session (Nursing/SW) Trauma Informed Care',
          speaker: 'Allison Mcgirr-Crowley'
        }
      ]
    },
    {
      time: '7:00 PM',
      sessions: [
        {
          text: 'NovoNordisk Dinner for SCD center members, more details pending',
          span: 7,
          isBold: true,
          isCentered: true
        }
      ]
    }
  ]
}

export const thursdayData: ScheduleDayProps = {
  title: 'Thursday · July 24 — Advanced Practice & Joint Sessions',
  gridCols: 8,
  headers: [
    { name: 'Time', location: '' },
    {
      name: 'N/A',
      location: 'Pinnacle',
      color: '#EDE6DE',
      textColor: '#3C2416'
    },
    {
      name: 'SCD and More',
      location: 'Stowe North',
      color: '#A0B2B4',
      textColor: '#3C2416'
    },
    {
      name: 'APP Track',
      location: 'Stowe South',
      color: '#AF8A48',
      textColor: '#3C2416'
    },
    {
      name: 'Nursing & Infusion',
      location: 'Beatrice',
      color: '#3C2416',
      textColor: 'white'
    },
    {
      name: 'N/A',
      location: 'Mansfield',
      color: '#EDE6DE',
      textColor: '#3C2416'
    },
    {
      name: 'SCD for Specialists',
      location: 'Stuart',
      color: '#713d43',
      textColor: 'white'
    },
    {
      name: 'SW / Care Coord / CBO',
      location: 'Green Mountain',
      color: '#894d35',
      textColor: 'white'
    }
  ],
  rows: [
    {
      time: '8:00 – 9:00 AM',
      sessions: [
        {
          text: 'Breakfast (Pinnacle)',
          span: 7,
          isBold: true,
          isCentered: true
        }
      ]
    },
    {
      time: '9:00 – 10:00 AM',
      sessions: [
        { text: 'GRNDaD Updates / Data Use', speaker: 'Sophie Lanzkron, MD' },
        { text: 'N/A', isMuted: true },
        {
          text: 'Building a Transition Program',
          speaker: 'Barbara Speller-Brown'
        },
        {
          text: 'Consensus Planning for Nursing in SCD',
          speaker: ['Maya Bloomberg MSN, APRN', 'Shannon Phillips RN PhD']
        },
        { text: 'N/A', isMuted: true },
        { text: 'Transfusion Basics', speaker: 'Jennifer Jones MD' },
        {
          text: 'Cultural Competency',
          speaker: ['Trudy Tchume-Johnson', 'Doreen Monroe']
        }
      ]
    },
    {
      time: '10:00 – 10:45 AM',
      sessions: [
        {
          text: 'Sanofi Diamond Lecture: Sickle Cell Disease:  Bridging Polymerization, Inflammation, and Innovation',
          speaker: ['Dr. Daak', 'Dr. Julie Kanter']
        },
        { text: 'N/A', isMuted: true },
        { text: 'Expansion of Services', speaker: 'Genice Nelson' },
        {
          text: 'Consensus Planning for Nursing in SCD',
          speaker: ['Maya Bloomberg MSN, APRN', 'Shannon Phillips RN PhD']
        },
        { text: 'N/A', isMuted: true },
        { text: 'Iron Overload Management', speaker: 'Samuel Wilson MD' },
        {
          text: 'The Important Steps of Behavioral Health in Gene Therapy',
          speaker: ['Shyranda Jones', 'Katrina Dalton']
        }
      ]
    },
    {
      time: '10:45 – 11:15 AM',
      sessions: [
        { text: 'Sanofi Diamond Lecture (cont.)' },
        { text: 'N/A', isMuted: true },
        { text: 'Break' },
        { text: 'Break' },
        { text: 'N/A', isMuted: true },
        { text: 'Break' },
        { text: 'Coffee & Questions' }
      ]
    },
    {
      time: '11:15 AM – 12:00 PM',
      sessions: [
        {
          text: 'Update from Washington DC',
          speaker: 'Ellen Riker, Advocacy Consultant, Artemis Policy Group'
        },
        { text: 'N/A', isMuted: true },
        {
          text: 'Nursing Research (Combined APP)',
          speaker: ['Shannon Phillips RN, PhD', 'Earleisha Felder, PA']
        },
        {
          text: 'Joint Session: Nursing Research (Combined APP) (in Stowe South)',
          speaker: ['Shannon Phillips RN, PhD', 'Earleisha Felder, PA']
        },
        { text: 'N/A', isMuted: true },
        {
          text: 'Building a Team',
          speaker: ['Sheinei Alan MD, PhD', 'Francis Coyne MD']
        },
        {
          text: 'Rewriting the Narrative: From Inherited Pain to Empowering Healing',
          speaker: 'Terance Dawkins'
        }
      ]
    },
    {
      time: '12:00 – 1:00 PM',
      sessions: [
        { text: 'Lunch (Pinnacle)', span: 7, isBold: true, isCentered: true }
      ]
    },
    {
      time: '1:00 – 1:45 PM',
      sessions: [
        { text: 'N/A', isMuted: true },
        { text: 'TCD QI', speaker: ['Kim Davidow, MD', 'Robin Miller MD'] },
        {
          text: 'High-Utilised Clinics: Resource Models',
          speaker: ['Genice Nelson', 'Christine Teklehaimanote']
        },
        { text: 'Gene Therapy or BMT?', speaker: 'Earleisha Felder, PA' },
        { text: 'N/A', isMuted: true },
        {
          text: 'Starting Infusion / Day Hospital',
          speaker: ['Sophie Lanzkron MD', 'Ashley Lauriello FNP']
        },
        {
          text: 'Next Steps for Social Workers at NASCC',
          speaker: 'Liddy Martin'
        }
      ]
    },
    {
      time: '1:45 – 2:30 PM',
      sessions: [
        { text: 'Management of the Complex Patient (Adol/Adult)' },
        { text: 'Pediatric Consensus Planning', speaker: 'Seethal Jacob MD' },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'N/A', isMuted: true },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'Joint Session (in Pinnacle)' }
      ]
    },
    {
      time: '2:30 – 3:00 PM',
      sessions: [
        { text: 'Management of the Complex Patient (Adol/Adult)' },
        { text: 'Stretch & Snack' },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'N/A', isMuted: true },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'Joint Session (in Pinnacle)' }
      ]
    },
    {
      time: '3:00 – 4:00 PM',
      sessions: [
        { text: 'Management of the Complex Patient (Adol/Adult)' },
        { text: 'Pediatric Consensus Planning', speaker: 'Seethal Jacob MD' },
        {
          text: 'More Consensus Planning (if needed)',
          speaker: ['Jennifer Saunders', 'Mica Fertis']
        },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'N/A', isMuted: true },
        { text: 'Joint Session (in Pinnacle)' },
        { text: 'Joint Session (in Pinnacle)' }
      ]
    },
    {
      time: '7:00 PM',
      sessions: [
        {
          text: 'Dinner on Your Own',
          span: 7,
          isBold: true,
          isCentered: true
        }
      ]
    }
  ]
}
